import { create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  GetCollegePredictorRequestType,
  GetCollegePredictorResponseType
} from './types';

import { NwCollegePredictorServiceTypes } from '.';

class NwCollegePredictorService implements NwCollegePredictorServiceTypes {
  api: Record<string, any>;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['NW_COLLEGE_PREDICTOR_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  getPredictedCollegeData = ({
    limit,
    offset,
    requestObject
  }: {
    limit: number;
    offset: number;
    requestObject: GetCollegePredictorRequestType;
  }): Promise<GetCollegePredictorResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `colleges/get/v2/?offset=${offset}&limit=${limit}`,
      requestObject,
      apiMethods.post
    );
  };
}

export { NwCollegePredictorService };
